export const getters = {
  systemBonds: state => state.bonds,
  Bond: state => state.systemBond,
  systemCustombonds: state => state.custombonds,
  Custombond: state => state.systemCustombond
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/bonds/getters.js